var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer_text"},[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+" e-Tax. All Rights Reserved.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }